import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../../../modal/PropdocsModal';
import { TitleFormattedMessage } from '../../../titleFormattedMessage';
import '../../../templates/ActiveInactiveDropdown.scss';

interface RemoveTeamMemberConfirmationModalProps {
  onHide: () => void;
  onClick: () => void;
  userToRemove: any;
}

const RemoveTeamMemberConfirmationModal = ({
  onHide,
  onClick,
  userToRemove,
}: RemoveTeamMemberConfirmationModalProps) => {
  const message = useMemo(() => {
    return (
      userToRemove && (
        <FormattedMessage
          id="phrase.confirm-removing-team-member"
          defaultMessage="Are you sure you would like to remove {fullName} from this workspace?"
          values={userToRemove}
        />
      )
    );
  }, [userToRemove]);

  return (
    <PropdocsModal
      show={!!userToRemove}
      setShow={onHide}
      title={<FormattedMessage id="title.remove-team-member" defaultMessage="Remove team member?" />}
      size="md"
    >
      <div className="confirmation-modal-content">
        <div className="confirmation-modal-body">{message}</div>
        <div className="confirmation-modal-actions">
          <Button variant="link" className="text-secondary" onClick={onHide}>
            <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="secondary" onClick={onClick}>
            <TitleFormattedMessage id="cta.remove" defaultMessage="Remove" />
          </Button>
        </div>
      </div>
    </PropdocsModal>
  );
};

export default RemoveTeamMemberConfirmationModal;
